<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title"><i class="fa fa-exchange-alt"></i>&nbsp; Invoice Reports</h4>
                                <h5 class="card-subtitle">Information about total invoice amount and due respect to customer</h5>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table no-wrap v-middle">
                                <thead>
                                <tr class="border-0">
                                    <th class="border-0"><h6>Customer Name</h6></th>
                                    <th class="border-0"><h6>Total Amount</h6></th>
                                    <th class="border-0"><h6>Amount Owed</h6></th>
                                    <th class="border-0"><h6>Action</h6></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(inv_report, index) in invoices_report">
                                    <td>{{inv_report.name}}</td>
                                    <td>{{inv_report.total | money}}</td>
                                    <td class="font-weight-bold text-danger" v-if="inv_report.due.amount && Number(inv_report.due.amount) > 0">{{inv_report.due | money}}</td>
                                    <td v-if="inv_report.due.amount && Number(inv_report.due.amount) === 0">{{inv_report.due | money}}</td>
                                    <td v-if="!inv_report.due.amount">0.00</td>
                                    <td>
                                        <a @click="viewSummary(inv_report.buyer_id)" href="javascript:void(0)">
                                            <h6>View Summary</h6>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "InvoicesReport",
        computed: {
            ...mapGetters(["currentOrg"])
        },
        data() {
            return {
                invoices_report: []
            };
        },
        mounted() {
            this.getInvoicesReport();
        },
        methods: {
            async getInvoicesReport() {
                $(".preloader").fadeIn();
                let result = await this.$http
                .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/invoicesReport");

                $(".preloader").fadeOut();
                this.invoices_report = result.data;
            },
            async viewSummary(memberid) {
                this.$router.push({name: "invoicessummary", params: {memberid: memberid}});
            }
        }
    }
</script>

<style scoped>

</style>
